import { FolderORM } from 'src/types/types'
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types'
import { useEffect } from 'react'

export const DNAFolderRow: DNARowsComponent<FolderORM> = () => {
  useEffect(() => {
    console.error('DNAFolderRow not implemented yet')
  }, [])

  return (null)
}

export default DNAFolderRow
